module.exports = __webpack_public_path__ + "static/media/full-screen-image-33.554ecf4e.jpg";